import profile from "../../../images/profileAvatar.jpg";

import { imageUrl } from '../../../config/api';
const buildLeaderImageUrl = (playerName) =>
    imageUrl(playerName);

function LeaderCard({ leader, accentTextClass, isAguada = true }) {
    return (
        <div className="bg-[#0f1f15] rounded-xl p-3 sm:p-4 border border-white/10 flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                <img
                    src={isAguada ? buildLeaderImageUrl(leader.name) : profile}
                    alt={leader.name}
                    className="w-14 h-14 sm:w-20 sm:h-20 rounded-full object-cover border border-white/15 bg-[#0f1f15] shrink-0"
                    loading="lazy"
                    onError={isAguada ? (event) => {
                        event.currentTarget.onerror = null;
                        event.currentTarget.src = profile;
                    } : undefined}
                />
                <div className="min-w-0">
                    <p className="text-slate-400 text-[10px] sm:text-xs font-bold uppercase tracking-wider">{leader.label}</p>
                    <h4 className="font-bold text-slate-100 mt-0.5 sm:mt-1 text-sm sm:text-base truncate">{leader.name}</h4>
                </div>
            </div>
            <p className={`${accentTextClass} text-2xl sm:text-3xl font-black tabular-nums shrink-0`}>{leader.value}</p>
        </div>
    );
}

function PartidoLeadersPanel({ leaders = [], rivalsLeaders = [], rivalName = "Rival", accent = "green", rivalAccent = "red" }) {
    const accentClass = accent === "red" ? "bg-red-500" : "bg-green-500";
    const rivalAccentClass = rivalAccent === "red" ? "bg-red-500" : "bg-green-500";

    const getLeaderColors = (aguadaValue, rivalValue) => {
        if (aguadaValue > rivalValue) {
            return { aguada: "text-green-400", rival: "text-red-400" };
        } else if (rivalValue > aguadaValue) {
            return { aguada: "text-red-400", rival: "text-green-400" };
        } else {
            return { aguada: "text-green-400", rival: "text-green-400" };
        }
    };

    return (
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
            <aside className="bg-[#102216] rounded-xl p-4 sm:p-6 border border-white/10">
                <h2 className="text-lg sm:text-2xl font-bold text-slate-100 flex items-center gap-2 mb-4 sm:mb-6">
                    <div className={`w-1.5 sm:w-2 h-6 sm:h-8 ${accentClass} rounded-full`}></div>
                    Líderes de Aguada
                </h2>

                <div className="space-y-3 sm:space-y-4">
                    {leaders.map((leader, index) => {
                        const rivalLeader = rivalsLeaders[index];
                        const colors = getLeaderColors(leader.value || 0, rivalLeader?.value || 0);
                        return (
                            <LeaderCard key={leader.id} leader={leader} accentTextClass={colors.aguada} isAguada={true} />
                        );
                    })}
                </div>
            </aside>

            <aside className="bg-[#102216] rounded-xl p-4 sm:p-6 border border-white/10">
                <h2 className="text-lg sm:text-2xl font-bold text-slate-100 flex items-center gap-2 mb-4 sm:mb-6">
                    <div className={`w-1.5 sm:w-2 h-6 sm:h-8 ${rivalAccentClass} rounded-full`}></div>
                    Líderes de {rivalName}
                </h2>

                <div className="space-y-3 sm:space-y-4">
                    {rivalsLeaders.map((leader, index) => {
                        const aguadaLeader = leaders[index];
                        const colors = getLeaderColors(aguadaLeader?.value || 0, leader.value || 0);
                        return (
                            <LeaderCard key={leader.id} leader={leader} accentTextClass={colors.rival} isAguada={false} />
                        );
                    })}
                </div>
            </aside>
        </div>
    );
}

export default PartidoLeadersPanel;
